import {
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
    Collapse,
} from "@material-tailwind/react";
import { FormControl, Select, InputLabel, MenuItem, Skeleton } from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React, { useEffect } from "react";
import { SettingContext } from "../App";

export function AllAreaSetting() {
    const { state, setting, setSetting } = React.useContext(SettingContext);
    // console.log("setting:", setting)

    const [activeTab, setActiveTab] = React.useState(state.setting.display.selected);
    const [areaLevel, setAreaLevel] = React.useState(state.setting.display.area.selected);

    const [dpcItems, setDPCItems] = React.useState([]);
    const [provItems, setProvItems] = React.useState([]);
    const [amphurItems, setAmphurItems] = React.useState([]);
    const [tambonItems, setTambonItems] = React.useState([]);
    const [orgItems, setORGItems] = React.useState([]);

    const [dpc, setDPC] = React.useState("");
    const [prov, setProv] = React.useState(null);
    const [amphur, setAmphur] = React.useState(null);
    const [tambon, setTambon] = React.useState(null);
    const [org, setORG] = React.useState(null);

    const handleTabChange = (value) => {
        if (value !== setting.display.selected) {
            setActiveTab(value)
            let _setting = { ...setting }
            _setting.display.selected = value
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    }


    const handleAreaLevelSelected = (event) => {
        setAreaLevel(event.target.value)
        let _setting = { ...setting }
        _setting.display.area.selected = event.target.value
        setSetting(_setting)
        // dispatch({
        //     type: "ON_SETTING_CHANGE",
        //     payload: _setting
        // })
    }

    const handleDPCSelected = (event) => {
        setDPC(event.target.value)
        let _setting = { ...setting }
        _setting.display.area.DPC = event.target.value
        setSetting(_setting)
        // dispatch({
        //     type: "ON_SETTING_CHANGE",
        //     payload: _setting
        // })
    }

    const handleChangeProv = (event, prov) => {
        if (prov !== null && prov.value !== setting.display.area.PROV) {
            setProv(prov);
            let _setting = { ...setting }
            _setting.display.area.PROV = prov.value
            _setting.display.area.PROV_NAME = prov.label
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    };

    const handleChangeAmphur = (event, amphur) => {
        if (amphur !== null && amphur.value !== setting.display.area.AMPHUR) {
            setAmphur(amphur);
            let _setting = { ...setting }
            _setting.display.area.AMPHUR = amphur.value
            _setting.display.area.AMPHUR_NAME = amphur.label
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    };

    const handleChangeTambon = (event, tambon) => {
        if (tambon !== null && tambon.value !== setting.display.area.tambon) {
            setTambon(tambon);
            let _setting = { ...setting }
            _setting.display.area.TAMBON = tambon.value
            _setting.display.area.TAMBON_NAME = tambon.label
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    };

    const handleChangeORG = (event, org) => {
        if (org !== null && org.value !== setting.display.org.selected) {
            setORG(org);
            let _setting = { ...setting }
            _setting.display.org.selected = org.value
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    };

    useEffect(() => {

        const fetchORG = async () => {
            // get the data from the api
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `bearer ${access_token}`
                }
            }
            const data = await fetch(`${process.env.REACT_APP_IAAMREG_HOST}/iaam-api/organization?per_page=100000`, options);
            // convert data to json
            const json = await data.json();
            let orgs = []
            json.organization.forEach(org => {
                orgs.push({
                    label: org.org_name,
                    value: org.org_id,
                })
            });
            // console.log(json);
            orgs = orgs.sort((a, b) => a.label.localeCompare(b.label, 'th'))
            setORGItems(orgs)
            setORG(orgs.find(p => p.value === state.setting.display.org.selected))
        }

        if (orgItems.length === 0) {
            fetchORG()
        }

    }, [activeTab])

    useEffect(() => {

        const fetchDPC = async () => {
            // get the data from the api
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `bearer ${access_token}`
                }
            }
            const data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_MASTER_PREFIX}/dpc/get_dpc`, options);
            // convert data to json
            const json = await data.json();
            setDPCItems(json)
            if (state.setting.display.area.DPC) {
                setDPC(state.setting.display.area.DPC)
            }
            else {
                setDPC(json[0].health_region_code)
            }
        }

        const fetchProv = async () => {
            // get the data from the api
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `bearer ${access_token}`
                }
            }
            const data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_MASTER_PREFIX}/area/province`, options);
            // convert data to json
            const json = await data.json();
            let provs = []
            json.forEach(prov => {
                provs.push({
                    label: prov.prov_namt,
                    value: prov.prov_code,
                })
            });
            // console.log(json);
            provs = provs.sort((a, b) => a.label.localeCompare(b.label, 'th'))
            setProvItems(provs)
            setProv(provs.find(p => p.value === state.setting.display.area.PROV))


            // if(prov === ""){
            //     setProv(provs[0].province_code)
            // }
        }

        if (areaLevel === "DPC") {
            if (dpcItems.length === 0) {
                fetchDPC().catch(console.error);
            }


        }

        if (["PROV", "AMPHUR", "TAMBON"].includes(areaLevel)) {

            if (provItems.length === 0)
                fetchProv().catch(console.error);

        }

    }, [areaLevel, dpcItems, provItems, dpc]);

    useEffect(() => {

        const fetchAmphur = async () => {
            setAmphur(null)
            setTambon(null)
            // get the data from the api
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `bearer ${access_token}`
                }
            }
            const amphur_data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_MASTER_PREFIX}/area/amphur?prov_code=${prov.value}`, options);
            // convert data to json
            const json = await amphur_data.json();
            let amphur_list = []
            json.forEach(amphur => {
                amphur_list.push({
                    label: amphur.amp_namt,
                    value: amphur.amp_code,
                })
            });
            amphur_list = amphur_list.sort((a, b) => a.label.localeCompare(b.label, 'th'))
            setAmphurItems(amphur_list)
            setAmphur(amphur_list.find(p => p.value === state.setting.display.area.AMPHUR))
            // setAmphur(undefined)
        }
        if (prov) {
            fetchAmphur().catch(console.error);
        }


    }, [prov]);

    useEffect(() => {

        const fetchTambon = async () => {
            setTambon(null)
            // get the data from the api
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `bearer ${access_token}`
                }
            }
            const tambon_data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_MASTER_PREFIX}/area/tambon?amp_code=${amphur.value}`, options);
            // convert data to json
            const json = await tambon_data.json();
            let tambon_list = []
            json.forEach(tambon => {
                tambon_list.push({
                    label: tambon.tambon_namt,
                    value: tambon.tambon_code,
                })
            });
            tambon_list = tambon_list.sort((a, b) => a.label.localeCompare(b.label, 'th'))
            setTambonItems(tambon_list)
            setTambon(tambon_list.find(p => p.value === state.setting.display.area.TAMBON))
        }
        if (amphur) {
            fetchTambon().catch(console.error);
        }


    }, [amphur]);



    const data = [
        {
            label: "พื้นที่",
            value: "area",
        },
        {
            label: "หน่วยงาน",
            value: "org",
        },

    ];

    const areaLevelItems = [
        {
            title: "ประเทศ",
            key: "TH",
        },
        {
            title: "เขตสุขภาพ",
            key: "DPC",
        },
        {
            title: "จังหวัด",
            key: "PROV",
        },
        {
            title: "อำเภอ",
            key: "AMPHUR",
        },
        {
            title: "ตำบล",
            key: "TAMBON",
        },

    ];

    const filterOptions = createFilterOptions({
        ignoreCase: true,
        limit: 20,
    });

    return (
        <>
            {
                state.setting.display.is_healht_org ? (
                    <Tabs id="area-animation" value={activeTab}>
                        <TabsHeader
                            id="area-tabs-header"
                            className="rounded-[4px] bg-red-50 border-red-200 border"
                            indicatorProps={{
                                className: "bg-red-900 shadow-none !text-gray-900",
                            }}>
                            {data.map(({ label, value }) => (
                                <Tab onClick={() => handleTabChange(value)} className={activeTab === value ? "text-white font-primary" : "text-gray-900 font-primary"} key={value} value={value}>
                                    {label}
                                </Tab>
                            ))}
                        </TabsHeader>
                        <TabsBody
                            animate={{
                                initial: { y: 60 },
                                mount: { y: 0 },
                                unmount: { y: 60 },
                            }}
                        >
                            <TabPanel key="area" value="area" className="px-0">
                                <FormControl className="w-full">
                                    <InputLabel id="area-level-select-label" className="font-primary">ระดับการแสดงผล</InputLabel>
                                    <Select
                                        labelId="area-level-select-label"
                                        id="area-level-select"
                                        value={areaLevel}
                                        label="ระดับการแสดงผล"
                                        size="small"
                                        onChange={handleAreaLevelSelected}
                                        className="font-primary"
                                        disabled={activeTab !== "area"}
                                    >
                                        {areaLevelItems.map(({ title, key }) => (
                                            <MenuItem value={key} key={key} className="font-primary">{title}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <div className="py-3" hidden={areaLevel !== "DPC"}>
                                    <Collapse className="h-full" open={areaLevel === "DPC"}>
                                        <div className="flex flex-col items-start gap-3 pt-2">
                                            <FormControl className="w-full">
                                                <InputLabel id="dpc-select-label" className="font-primary">เขตสุขภาพ</InputLabel>
                                                <Select
                                                    labelId="dpc-select-label"
                                                    id="dpc-select"
                                                    value={dpc}
                                                    label="เขตสุขภาพ"
                                                    size="small"
                                                    onChange={handleDPCSelected}
                                                    className="font-primary"
                                                    disabled={areaLevel !== "DPC" || activeTab !== "area"}
                                                    MenuProps={{
                                                        sx: {
                                                            "&& .Mui-selected": {
                                                                backgroundColor: "#b73238",
                                                                color: "#fff"
                                                            },
                                                            "&& .MuiMenuItem-root:hover": {
                                                                backgroundColor: "#ffebee",
                                                                color: "#000"
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {
                                                        dpcItems ? (
                                                            dpcItems.map(({ health_region_name, health_region_code }) => (
                                                                <MenuItem value={health_region_code} key={health_region_code} className="font-primary">{health_region_name}</MenuItem>
                                                            ))
                                                        ) : (
                                                            <Skeleton variant="text" className="w-full" />
                                                        )}
                                                </Select>
                                            </FormControl>
                                        </div>

                                    </Collapse>
                                </div>
                                <div className="py-3" hidden={areaLevel !== "PROV"}>
                                    <Collapse open={areaLevel === "PROV"}>
                                        <div className="flex flex-col items-start gap-3 pt-1">
                                            <Autocomplete
                                                className="font-primary text-base w-full pt-[2px]"
                                                id="combo-box-prov"
                                                options={provItems}
                                                size="small"
                                                clearIcon={false}
                                                value={prov ? prov : null}
                                                onChange={handleChangeProv}
                                                disabled={areaLevel !== "PROV" || activeTab !== "area"}
                                                ListboxProps={{ className: "font-primary" }}
                                                renderInput={(params) =>
                                                    <TextField {...params} size="small"
                                                        InputLabelProps={{ className: "font-primary" }}
                                                        label="จังหวัด"
                                                        InputProps={{ ...params.InputProps, className: "font-primary" }}
                                                    />}
                                            />

                                        </div>

                                    </Collapse>
                                </div>
                                <div className="py-3" hidden={areaLevel !== "AMPHUR"}>
                                    <Collapse open={areaLevel === "AMPHUR"}>
                                        <div className="flex flex-col items-start gap-3 pt-1">
                                            <Autocomplete
                                                className="font-primary text-base w-full pt-[2px]"
                                                id="combo-box-a-prov"
                                                options={provItems}
                                                size="small"
                                                clearIcon={false}
                                                value={prov ? prov : null}
                                                onChange={handleChangeProv}
                                                disabled={areaLevel !== "AMPHUR" || activeTab !== "area"}
                                                ListboxProps={{ className: "font-primary" }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        InputLabelProps={{ className: "font-primary" }}
                                                        label="จังหวัด"
                                                        InputProps={{ ...params.InputProps, className: "font-primary" }}
                                                    />}
                                            />
                                            <Autocomplete
                                                className="font-primary text-base w-full pt-[2px]"
                                                id="combo-box-a-amphur"
                                                options={amphurItems}
                                                size="small"
                                                clearIcon={false}
                                                value={amphur ? amphur : null}
                                                onChange={handleChangeAmphur}
                                                disabled={(areaLevel !== "AMPHUR" && amphurItems.length < 1) || activeTab !== "area"}
                                                ListboxProps={{ className: "font-primary" }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        InputLabelProps={{ className: "font-primary" }}
                                                        label="อำเภอ"
                                                        InputProps={{ ...params.InputProps, className: "font-primary" }}
                                                    />}
                                            />
                                        </div>

                                    </Collapse>
                                </div>
                                <div className="py-3" hidden={areaLevel !== "TAMBON"}>
                                    <Collapse open={areaLevel === "TAMBON"}>
                                        <div className="flex flex-col items-start gap-3 pt-1">
                                            <Autocomplete
                                                className="font-primary text-base w-full pt-[2px]"
                                                id="combo-box-t-prov"
                                                options={provItems}
                                                size="small"
                                                clearIcon={false}
                                                value={prov ? prov : null}
                                                onChange={handleChangeProv}
                                                disabled={areaLevel !== "TAMBON" || activeTab !== "area"}
                                                ListboxProps={{ className: "font-primary" }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        InputLabelProps={{ className: "font-primary" }}
                                                        label="จังหวัด"
                                                        InputProps={{ ...params.InputProps, className: "font-primary" }}
                                                    />}
                                            />
                                            <Autocomplete
                                                className="font-primary text-base w-full pt-[2px]"
                                                id="combo-box-t-amphur"
                                                options={amphurItems}
                                                size="small"
                                                clearIcon={false}
                                                value={amphur ? amphur : null}
                                                onChange={handleChangeAmphur}
                                                disabled={(areaLevel !== "TAMBON" && amphurItems.length < 1) || activeTab !== "area"}
                                                ListboxProps={{ className: "font-primary" }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        InputLabelProps={{ className: "font-primary" }}
                                                        label="อำเภอ"
                                                        InputProps={{ ...params.InputProps, className: "font-primary" }}
                                                    />}
                                            />
                                            <Autocomplete
                                                className="font-primary text-base w-full pt-[2px]"
                                                id="combo-box-t-tambon"
                                                options={tambonItems}
                                                size="small"
                                                clearIcon={false}
                                                value={tambon ? tambon : null}
                                                onChange={handleChangeTambon}
                                                disabled={(areaLevel !== "TAMBON" && tambonItems.length < 1) || activeTab !== "area"}
                                                ListboxProps={{ className: "font-primary" }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        InputLabelProps={{ className: "font-primary" }}
                                                        label="ตำบล"
                                                        InputProps={{ ...params.InputProps, className: "font-primary" }}
                                                    />}
                                            />
                                        </div>

                                    </Collapse>
                                </div>

                            </TabPanel>
                            <TabPanel key="org" value="org" className="px-0">
                                {/* <Autocomplete
                    disablePortal
                    id="combo-box-org"
                    options={orgItems}
                    size="small"
                    value={org? org: null}
                    disabled={activeTab !== "org"}
                    onChange={handleChangeORG}
                    ListboxProps={{className:"font-primary"}}
                    renderInput={(params) => <TextField {...params} InputLabelProps={{className:"font-primary"}} label="หน่วยงาน" fullWidth/>}
                />    */}
                                <Autocomplete
                                    className="font-primary text-base w-full pt-[2px]"
                                    id="combo-box-org"
                                    options={orgItems}
                                    size="small"
                                    clearIcon={false}
                                    value={org ? org : null}
                                    disabled={activeTab !== "org"}
                                    onChange={handleChangeORG}
                                    filterOptions={filterOptions}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            label="หน่วยงาน"
                                        />}
                                />

                            </TabPanel>
                            {/* {data.map(({ value, desc }) => (
            <TabPanel key={value} value={value}>
              {desc}
            </TabPanel>
          ))} */}
                        </TabsBody>
                    </Tabs>
                ) : (
                    <TextField
                        className="w-full"
                        id="org-only"
                        label="หน่วยงาน"
                        defaultValue={state.setting.display.org.name}
                        variant="outlined"
                        size="small"
                        slotProps={{
                            input: {
                                readOnly: true,
                            },
                        }}
                    />
                )
            }

        </>

    );
}